'use client';

import React, {HTMLAttributes} from 'react';

import VillageGallery from '../VillageGallery';
import {useGallery} from '@/hooks/useGalleryContext';
import {IRegionZoneDictonary} from '@/dictionaries/utils/region-zone/types';
import {IVillageDictionary} from '@/dictionaries/pages/village/types';

type VillageCarouselGalleryDicts = {
  regionZoneDict: IRegionZoneDictonary;
  villageDict: IVillageDictionary;
};

interface IVillageCarouselGalleryProps extends HTMLAttributes<HTMLDivElement> {
  lang: string;
  dicts: VillageCarouselGalleryDicts;
}

export const VillageCarouselGallery: React.FC<IVillageCarouselGalleryProps> = ({
  lang,
  dicts,
}) => {
  const {changeVillageInfo, villa} = useGallery();

  return (
    villa && (
      <VillageGallery
        village={villa}
        handleClose={() => changeVillageInfo(undefined)}
        lang={lang}
        dicts={dicts}
      />
    )
  );
};
